import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Modal, Button, Header, Icon, Table } from 'semantic-ui-react';

import { LoadingBar } from 'components/Commons';
import { PolicyList } from 'components/SikdaePolicy';

import cm from 'helpers/commons';

class SikdaeGroupDtlModal extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { sikdaePolicy } = this.props,
      { close, open, name } = this.props.varModal,
      PolicyListFn = {
        sikdaePolicy: sikdaePolicy
      };

    const header = name + ' 식대정책';

    return (
      <Modal className="signup-selected-modal modal-medium" open={open} onClose={close}>
        <Header content={header} />

        <Modal.Content>
          {sikdaePolicy && sikdaePolicy.data ? <PolicyList PolicyListFn={PolicyListFn} /> : <LoadingBar />}
        </Modal.Content>

        <Modal.Actions>
          <Button positive content="닫기" onClick={close} />
        </Modal.Actions>
      </Modal>
    );
  }
}

SikdaeGroupDtlModal = connect(
  (state) => ({
    sikdaePolicy: state.commons.sikdaePolicy
  }),
  (dispatch) => ({})
)(SikdaeGroupDtlModal);

export default SikdaeGroupDtlModal;
